// React
import { FunctionComponent, useState } from "react"

// Interfaces
import { I_SafetyEvent, I_SafetyEventWithApprovalHistory } from "../../../interfaces"

//Services
import VIS from "src/pages/vehicle_incidents/VehicleIncidentsService"

// Subcomponent
import VehicleIncidentsTableBodyTR from "./VehicleIncidentsTableBodyTR"

interface Props {
  events: I_SafetyEvent[] | I_SafetyEventWithApprovalHistory[]
  loader: number
}

/**
 * Renders the <tbody> portion of the vehicle incidents table.
 * Tracks clicked video links, highlights active rows, and conditionally shows row actions.
 */
const VehicleIncidentsTableBody: FunctionComponent<Props> = (props) => {

  const { events, loader } = props

  const { setOpenVideo } = VIS

  const [clickedLinks, setClickedLinks] = useState<Set<number>>(() => new Set())
  const [activeRow, setActiveRow] = useState<number | null>(null)

  /**
   * Handles link click: highlights row, tracks it as clicked, and opens URL.
   */
  const handleLinkClick = (id: number) => {
    setClickedLinks(prev => new Set(prev).add(id))
    setActiveRow(id)
    setOpenVideo(id)
  }

  return (
    <tbody>
      {events.map((eventItem, i) => {

        const rowActive = activeRow === eventItem.ObjectID

        return (
          <VehicleIncidentsTableBodyTR
            key={eventItem.ID}
            i={i}
            rowActive={rowActive}
            eventItem={eventItem}
            handleLinkClick={handleLinkClick}
            clickedLinks={clickedLinks}
            loader={loader}
          />
        )
      })}
    </tbody>
  )
}

export default VehicleIncidentsTableBody